import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Typography,
  Stack,
  Container,
  ImageList,
  ImageListItem,
  Box,
  Grid,
} from "@mui/material";
import ImageViewer from "react-simple-image-viewer";
import { style } from "@mui/system";

const UserGallery = ({ currentValue, galleryPics }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isGalViewerOpen, setIsGalViewerOpen] = useState(false);

  useEffect(() => {
    if (currentValue == "gallery") {
      gallery.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentValue]);

  const gallery = useRef();

  const imgLength = galleryPics.slice(2);
  const galImg = galleryPics.slice(0, 2);

  const [showMore, setShowMore] = useState(false);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const closeGalImageViewer = () => {
    setCurrentImage(0);
    setIsGalViewerOpen(false);
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const openGalImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsGalViewerOpen(true);
  }, []);

  return (
    <div>
      <Container className="mt-10">
        <Stack>
          <Stack>
            <Typography variant="h6" gutterBottom component="div" ref={gallery}>
              Gallery
            </Typography>
          </Stack>

          {/* <Stack direction='row'>
                        {itemData.map((item) => (
                            <div key={item.img}>

                                <img
                                    src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                                    srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                    alt={item.title}
                                    loading="lazy"
                                />

                            </div>
                        ))}
                    </Stack> */}

          {showMore ? (
            <Grid container rowSpacing={3}>
              {galleryPics.map((item, index) => (
                <Grid item sm={2}>
                  {/* <Box
                    sx={{
                      width: 120,
                      height: 120,
                    }}
                  > */}
                  <div class="middle2">
                    <img
                      src={item}
                      style={{
                        height: "120px",
                        width: "120px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      alt="Banner Person"
                      onClick={() => openImageViewer(index)}
                    />
                  </div>
                  {/* </Box> */}
                </Grid>
              ))}
              <Grid item xs={6} sm={3}>
                <div onClick={() => setShowMore(false)}>
                  <Box
                    sx={{
                      width: 120,
                      height: 120,
                      backgroundColor: "#0a64bc1c",
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      class="middle2"
                      style={{ position: "relative", top: "40px" }}
                    >
                      <div> View Less</div>
                    </div>
                  </Box>
                </div>
              </Grid>
            </Grid>
          ) : (
            <Grid container rowSpacing={3}>
              {galImg.map((item, index) => (
                <Grid item sm={2}>
                  {/* <Box
                    sx={{
                      width: 120,
                      height: 120,
                    }}
                  > */}
                  <div class="middle2">
                    <img
                      src={item}
                      style={{
                        height: "120px",
                        width: "120px",
                        objectFit: "contain",
                        cursor: "pointer",
                      }}
                      alt="Banner Person"
                      onClick={() => openGalImageViewer(index)}
                    />
                  </div>
                  {/* </Box> */}
                </Grid>
              ))}
              {imgLength.length > 0 && (
                <Grid item xs={6} sm={3}>
                  <div onClick={() => setShowMore(true)}>
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        backgroundColor: "#0a64bc1c",
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        class="middle2"
                        style={{ position: "relative", top: "40px" }}
                      >
                        <div> View All</div>
                        <div>+{imgLength.length}</div>
                      </div>
                    </Box>
                  </div>
                </Grid>
              )}
            </Grid>
          )}
          {isViewerOpen && (
            <ImageViewer
              src={galleryPics}
              currentIndex={currentImage}
              onClose={closeImageViewer}
              disableScroll={true}
              backgroundStyle={{
                backgroundColor: "rgba(0,0,0,0.9)",
              }}
              closeOnClickOutside={true}
            />
          )}
          {isGalViewerOpen && (
            <ImageViewer
              src={galImg}
              currentIndex={currentImage}
              onClose={closeGalImageViewer}
              disableScroll={true}
              backgroundStyle={{
                backgroundColor: "rgba(0,0,0,0.9)",
              }}
              closeOnClickOutside={true}
            />
          )}
          {/* <Stack direction="row" spacing={2}>
              <Stack direction="row" spacing={2}>
                {galImg.map((item) => (
                  <Box
                    sx={{
                      width: 120,
                      height: 120,
                      backgroundColor: "#0a64bc1c",
                    }}
                  >
                    <div
                      class="middle2"
                      
                    >
                      <img
                        src={item.img}
                        style={{ height: "120px" }}
                        alt="Banner Person"
                      />
                    </div>
                  </Box>
                ))}
              </Stack>
              <Stack>
                <Box
                  sx={{
                    width: 120,
                    height: 120,
                    backgroundColor: "#0a64bc1c",
                  }}
                >
                  <div
                    class="middle2"
                    
                  >
                    <div>+{imgLength.length}</div>
                    <br />
                    <div> View All</div>
                  </div>
                </Box>
              </Stack>
            </Stack> */}
        </Stack>
      </Container>
    </div>
  );
};

export default UserGallery;
